import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cachedSettings = null;

export function usePublicSettings() {
  const [settings, setSettings] = useState(cachedSettings || { google_auth_enabled: true, site_name: "RankifyLocal" });

  useEffect(() => {
    if (cachedSettings) return;
    axios.get(`${API}/admin/public-settings`)
      .then(res => {
        cachedSettings = res.data;
        setSettings(res.data);
      })
      .catch(() => {});
  }, []);

  return settings;
}
